<template>
<div class="home guide-page page-template-default page separate-containers nav-below-header">
  <HeadNav selectedLanguage="en" page="faq" />
  <GuideBreadcrumb :items="[{ label: 'Home', href: '/' }, { label: 'FAQ' }]" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <section class="entry-wrapper hero">
            <div class="hero-shell hero-shell--guide">
              <header class="hero-top">
                <p class="hero-kicker">FAQ</p>
                <h1>Frequently Asked Questions</h1>
              </header>
              <div class="hero-copy">
                <p v-html="intro.lead" />
                <p class="faq-intro-note">{{ intro.note }}</p>
              </div>
            </div>
          </section>

          <div class="section-content">
            <h2 class="h">Common questions</h2>
            <section
              v-for="group in faqGroups"
              :key="group.id"
              class="faq-group"
            >
              <h3 class="faq-group-title">{{ group.title }}</h3>
              <FAQ :faqs="group.items" />
            </section>
          </div>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gb-home-layout.scss'
import '@/css/guide-pages.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'
import FAQ from '@/components/FAQ.vue'
import { faqGroups, faqIntro } from '@/data/faqPage'

export default {
  name: 'FaqPage',
  components: { HeadNav, GuideBreadcrumb, FAQ },
  data() {
    return { faqGroups, intro: faqIntro }
  },
}
</script>

<style lang="scss" scoped>
.faq-intro-note {
  margin-top: 0.75em;
  font-size: 0.9375rem;
  color: #64748b;
}

.faq-group {
  margin-top: 2rem;

  &:first-of-type {
    margin-top: 1.25rem;
  }
}

.faq-group-title {
  margin: 0 0 0.75rem;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
}
</style>
